import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'gofwry',
      component: resolve => require(['@/components/home/gofwry'], resolve)
    },
    {
      path: '/Feedback',
      name: 'Feedback',
      component: resolve => require(['@/components/feedBack/Feedback'], resolve)
    },
    {
      path: '/History',
      name: 'History',
      component: resolve => require(['@/components/feedBack/History'], resolve)
    },
    {
      path: '/jyaqts',
      name: 'jyaqts',
      component: resolve => require(['@/components/jyaqts/jyaqts'], resolve)
    },
    {
      path: '/yszc',
      name: 'yszc',
      component: resolve => require(['@/components/yszc/yszc'], resolve)
    },
    {
      path: '/testServer',
      name: 'testServer',
      component: resolve => require(['@/components/testserver/testServer'], resolve)
    },
    {
      path: '/safety',
      name: 'safety',
      component: resolve => require(['@/components/safety/safety'], resolve)
    },
    {
      path: '/message',
      name: 'message',
      component: resolve => require(['@/components/safety/message'], resolve)
    },
    {
      path: '/detection',
      name: 'detection',
      component: resolve => require(['@/components/safety/detection'], resolve)
    },
    {
      path: '/loginLog',
      name: 'loginLog',
      component: resolve => require(['@/components/safety/loginLog'], resolve)
    },
    {
      path: '/equipment',
      name: 'equipment',
      component: resolve => require(['@/components/safety/equipment'], resolve)
    },
    {
      path: '/teachClass',
      name: 'teachClass',
      component: resolve => require(['@/components/safety/teachClass'], resolve)
    },
    {
      path: '/detailsPage',
      name: 'detailsPage',
      component: resolve => require(['@/components/safety/detailsPage'], resolve)
    },
    {
      path: '/shareFriend',
      name: 'shareFriend',
      component: resolve => require(['@/components/shareFriend/shareFriend'], resolve)
    },
    {
      path: '/levelTwo',
      name: 'levelTwo',
      component: resolve => require(['@/components/levelTwo/levelTwo'], resolve)
    },
    {
      path: '/honorsystem',
      name: 'honorsystem',
      // component: resolve => require(['@/components/honorsystem/index'], resolve)
      component: resolve => require(['@/components/honorsystemV2/index'], resolve)
    },
    {
      path: '/honorsystem/honordetails',
      name: 'honordetails',
      // component: resolve => require(['@/components/honorsystem/honordetails'], resolve)
      component: resolve => require(['@/components/honorsystemV2/honordetails'], resolve)
    },
    {
      path: '/honorsystem/honorfx',
      name: 'honorfx',
      // component: resolve => require(['@/components/honorsystem/honorfx'], resolve)
      component: resolve => require(['@/components/honorsystemV2/honorfx'], resolve)
    },
    {
      path: '/honorsystem/honorxq',
      name: 'honorxq',
      // component: resolve => require(['@/components/honorsystem/honorxq'], resolve)
      component: resolve => require(['@/components/honorsystemV2/honorxq'], resolve)
    },
    {
      path: '/ytgxc',
      name: 'ytgxc',
      component: resolve => require(['@/components/ytgxcy/ytgxc'], resolve)
    },
    {
      path: '/phonebind',
      name: 'phonebind',
      component: resolve => require(['@/components/phoneNum/phonebind'], resolve)
    },
    {
      path: '/openqht',
      name: 'openqht',
      component: resolve => require(['@/components/openqht/home'], resolve)
    },
    {
      path: '/sjgg',
      name: 'sjgg',
      component: resolve => require(['@/components/yszc/sjgg'], resolve)
    },
    {
      path: '/accountBind',
      name: 'accountBind',
      component: resolve => require(['@/components/accountBind/accountBind'], resolve)
    },
    {
      path: '/cards',
      name: 'cards',
      component: resolve => require(['@/components/cards/index'], resolve)
    },
    {
      path: '/historyCards',
      name: 'historyCards',
      component: resolve => require(['@/components/cards/history'], resolve)
    },
    {
      path: '/choice',
      name: 'choice',
      component: resolve => require(['@/components/cards/choice'], resolve)
    },
    {
      path: '/feekdetal',
      name: 'feekdetal',
      component: resolve => require(['@/components/feedBack/feekdetal'], resolve)
    },
    {
		path: '/wxtx/index',
		name: 'home',
		component: resolve => require(['@/components/wxtx/home'], resolve)
	},
	{
		path: '/wxtx/bing',
		name: 'bing',
		component: resolve => require(['@/components/wxtx/bing'], resolve)
	},
	{
		path: '/wxtx/detil',
		name: 'detil',
		component: resolve => require(['@/components/wxtx/detil'], resolve)
	},
    {
      path: '/mmjpsz',
      name: 'mmjpsz',
      component: resolve => require(['@/components/safety/mmjpsz'], resolve)
    },
	{
		path: '/phoneCancel/xhend',
		name: 'phoneCancel',
		component: resolve => require(['@/components/phoneCancel/xhend'], resolve)
	},
	{
		path: '/phoneCancel/sign',
		name: 'phoneCancelsign',
		component: resolve => require(['@/components/phoneCancel/sign'], resolve)
	},
	{
		path: '/phoneCancel/cancel',
		name: 'phoneCancelcancel',
		component: resolve => require(['@/components/phoneCancel/cancel'], resolve)
	},
	{
		path: '/phoneCancel/next',
		name: 'phoneCancelnext',
		component: resolve => require(['@/components/phoneCancel/next'], resolve)
	},
	{
		path: '/phoneCancel/intercept',
		name: 'phoneCancelintercept',
		component: resolve => require(['@/components/phoneCancel/intercept'], resolve)
	},
	{
	  path: '/fwryinfo',
	  name: 'fwryinfo',
	  component: resolve => require(['@/components/home/fwryinfo'], resolve)
	},
	{
	  path: '/fwryhome',
	  name: 'fwryhome',
	  component: resolve => require(['@/components/home/Home'], resolve)
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js